import MousePararax from './pararax'
import MouseMotion from './motion'

/* ---------------------------------------

    -- マウス動作に合わせていい感じに値を返すやつ

--------------------------------------- */

export default class MouseManager {
    constructor(scroll,util) {
        /* ポインターの位置情報 */
        this.pointer = {
            x: window.innerWidth/2,
            y: window.innerHeight/2,
        }
        /* 慣性動作後の値 */
        this.obj = {
            x: window.innerWidth/2,
            y: window.innerHeight/2,
            maskX: window.innerWidth/2,
            maskY: window.innerHeight/2,
        }

        /* 設定はここ */
        this.conf = {
            ease: 0.1,
        }

        this.status = {
            off: false,
            active: Useragnt.pc ? true : false,
            fitActive: true,
            deviceSize: 'pc',
            hover: false,
            slider: false,
            sliderDir: 'next',
            loaded: false,
            fixedCircle:true
        }

        this.scroll = scroll;
        this.util = util;

        this.$modal
        this.$pointer
        this.$pointerCircle
        this.$fixCircle
        this.$link
        this.$pointerIcon

        this.process = {} //処理パターンを管理

        this.timer = {
            resize: '',
        }

        this.motion = new MouseMotion()

        this.wHalf

        this.time = 0

        this.maskOff = false
    }
    init(scroll, webgl) {

        this.$modal = document.getElementById("p-kv-modal")
        this.$pointer = document.getElementById('fix-pointer')
        this.$pointerCircle = document.getElementById('m-pointer-circle-color')
        this.$link = document.querySelectorAll('.js__pointer-hover')
        this.$mask = document.querySelector('.l-bg_color');

        this.$fixCircle = document.getElementById("fix-circle")
        this.$pointerIcon = this.$pointer.querySelectorAll('.line-color')

        // this.effect.svg(this.$pointer.querySelectorAll('.js__svg'), 'set')
        // this.effect.svgFill(
        //     this.$pointer.querySelectorAll('.js__svg-fill'),
        //     'set'
        // )

        setTimeout(()=>{

            this.obj.x = this.pointer.x;
            this.obj.y = this.pointer.y;

            TweenLite.to([this.$fixCircle,this.$pointer], 1 ,{
                x: this.obj.x,
                y: this.obj.y,
            })
            let _scr = window.pageYOffset || document.documentElement.scrollTop;
            TweenMax.to(this.$mask, 1 ,{
                css: {
                    '-webkit-mask-position-x': this.obj.x-225,
                    '-webkit-mask-position-y': this.obj.y-225 + _scr,
                    'mask-position-x': this.obj.x-225,
                    'mask-position-y': this.obj.y-225 + _scr
                },
                onComplete: () => {
                    this.status.loaded = true;
                }
            })

        },5e3)


        for (let i in this.$link) {
            if (this.$link[i].nodeType != 1) continue // dom要素以外は処理止める

            this.$link[i].addEventListener('mousemove', e => {
                if (this.status.hover) return
                this.status.hover = true

                // this.motion.scaleUP(this.$pointerCircle)

                if (e.target.classList.contains('is-detail')) {
                    this.motion.opOut(this.$fixCircle)
                    this.iconMotDisplay();
                    this.motion.opShow(this.$pointer)
                    if(this.$modal.classList.contains("is-open")){
                        this.$pointer.classList.add("is-close")
                    }else{
                        this.$pointer.classList.remove("is-close")
                    }
                }
            })
            this.$link[i].addEventListener('mouseleave', e => {
                if (!this.status.hover) return
                this.status.hover = false
                this.status.slider = false

                this.motion.scaleDown(this.$pointerCircle)

                if (e.target.classList.contains('is-detail')) {
                    this.motion.opOut(this.$pointer)
                    this.iconMotDisplay();
                    this.motion.opShow(this.$fixCircle)
                }
            })
        }
    }
    iconMot() {

        TweenMax.staggerTo(this.$pointerIcon, 0.4, {
            x: -110 + '%',
            ease: Power2.easeOut,
            onComplete: () => {

            },
        },0.05,()=>{
            if(this.$modal.classList.contains("is-open")){
                this.$pointer.classList.add("is-close")
            }else{
                this.$pointer.classList.remove("is-close")
            }

            TweenMax.staggerTo(this.$pointerIcon, 0.4, {
                x: 0 + '%',
                ease: Power2.easeOut,
            },0.05)


        })


    }
    iconMotDisplay() {

        TweenMax.staggerTo(this.$pointerIcon, 0.2, {
            x: -110 + '%',
            ease: Power2.easeOut,
            onComplete: () => {

            },
        },0.05,()=>{
            TweenMax.staggerTo(this.$pointerIcon, 0.2, {
                x: 0 + '%',
                delay : 0.3,
                ease: Power2.easeOut,
            },0.05)


        })


    }
    move(scroll) {

        /* domにスタイル付けるなら("set",$target) | 値が欲しいだけなら()なし */

        if (!this.status.loaded || this.status.off||!scroll.status.comp) return

        this.obj.x += (this.pointer.x - this.obj.x) * this.conf.ease
        this.obj.y += ((this.pointer.y+ scroll.inc) - this.obj.y) * this.conf.ease

        this.time += 1

        if(this.time%3!=0) return

        if(scroll.contents.kv.show){
            this.maskOff = false
            this.obj.maskX = this.obj.x - 225
            this.obj.maskY = this.obj.y - 225 + this.scroll.nowInc
            TweenLite.set([this.$fixCircle,this.$pointer], {
                x: this.obj.x,
                y: this.obj.y,
            })
            TweenMax.set(this.$mask, {
                css: {
                    '-webkit-mask-position-x': this.obj.maskX,
                    '-webkit-mask-position-y': this.obj.maskY,
                    'mask-position-x': this.obj.maskX,
                    'mask-position-y': this.obj.maskY
                }
            })
        }else{

            if(!this.maskOff){
                this.maskOff = true
                TweenMax.killTweensOf(this.$mask,{css:true} );
            }

        }


        // this.pararax.render(
        //     this.scroll.contents.status.current,
        //     this.obj.x,
        //     this.obj.y,
        //     this.scroll.status.exResizeMode
        // )

        // TweenLite.set(this.$pointerDotted,{
        //     x : this.pointer.x,
        //     y : this.pointer.y
        // })

        // this.$pointerDotted.style.transform = 'translateY(-'+ this.pointer.y +'px)';
    }
    fit($target, mode) {
        if (
            this.status.off ||
            this.status.deviceSize == 'sp' ||
            Useragnt.mobile ||
            Useragnt.tablet ||
            !this.status.fitActive
        )
            return

        if (mode == 'move') {
            let _w = $target.clientWidth,
                _h = $target.clientHeight,
                _rect = $target.getBoundingClientRect(),
                _x = _rect.left,
                _y = _rect.top,
                _fx = (this.pointer.x - _x) / _w - 0.5,
                _fy = (this.pointer.y - _y) / _h - 0.5

            // console.log("fitHoverMove",_x,_y,_fx,_fy,_rect,this.state.mouse.x)
            TweenLite.to($target.querySelectorAll('.js__m-fit'), 0.2, {
                x: _w < 100 ? _fx * _w * 0.5 : _fx * _w * 0.07,
                y: _h < 100 ? _fy * _h * 0.5 : _fy * _h * 0.07,
            })
        } else {
            TweenLite.to($target.querySelectorAll('.js__m-fit'), 0.2, {
                x: 0,
                y: 0,
            })
        }
    }
    update(x, y) {
        if (this.status.off) return

        if (Useragnt.pc) {
            this.pointer.x = x
            this.pointer.y = y
        } else {
            this.pointer.x = x
            this.pointer.y = -y
        }

        //スライダーにマウスオンしている場合
        if (this.status.slider) {
            if (this.wHalf > this.pointer.x) {
                if (this.status.sliderDir != 'prev')
                    this.motion.arrowRot(
                        this.$pointer.querySelector('.arrow'),
                        'prev'
                    )
                this.status.sliderDir = 'prev'
            } else {
                if (this.status.sliderDir != 'next')
                    this.motion.arrowRot(
                        this.$pointer.querySelector('.arrow'),
                        'next'
                    )
                this.status.sliderDir = 'next'
            }
        }
    }
    resize(w, h, displayType) {
        this.wHalf = w / 2
    }
    maskShow(){
        TweenMax.to(this.$mask, 0.4, {
            css: {
                '-webkit-mask-size': '450px 450px',
                'mask-size': '450px 450px',
            },
        })
    }
    maskOut(){
        TweenMax.to(this.$mask, 0.4, {
            css: {
                '-webkit-mask-size': '0px 0px',
                'mask-size': '0px 0px',
            },
        })
    }
    wheel(scroll){

        if(scroll.inc > 200){
            this.motion.opOut(this.$pointer);
        }

    }
}
